module.exports = __webpack_public_path__ + "media/images/subject_img/HISTORY OF ART-77391a128d0fcb224b5da78bea102342.jpg";